const Vue = require('vue')
const zipcodeSearchModalTemplate = require('templates/ui-zipcode-search.html')
const client = require('../helpers/client')

const buildDefaults = () => {
    return {
        results: [],
        isLoading: false,
        pagination: {
            per_page: 0,
            total_pages: 0,
            total: 0,
            count: 0,
            current_page: 0
        },
        ui: {
            state: null,
            address: null,
            city: null,
            neighborhood: null,
            page: 1
        },
        filters: {
            states: [],
            cities: [],
            neighborhoods: []
        },
        options: {
            states: [
                { 'name': 'Acre', 'abbreviation': 'AC' },
                { 'name': 'Alagoas', 'abbreviation': 'AL' },
                { 'name': 'Amapá', 'abbreviation': 'AP' },
                { 'name': 'Amazonas', 'abbreviation': 'AM' },
                { 'name': 'Bahia', 'abbreviation': 'BA' },
                { 'name': 'Ceará', 'abbreviation': 'CE' },
                { 'name': 'Distrito Federal', 'abbreviation': 'DF' },
                { 'name': 'Espírito Santo', 'abbreviation': 'ES' },
                { 'name': 'Goiás', 'abbreviation': 'GO' },
                { 'name': 'Maranhão', 'abbreviation': 'MA' },
                { 'name': 'Mato Grosso', 'abbreviation': 'MT' },
                { 'name': 'Mato Grosso do Sul', 'abbreviation': 'MS' },
                { 'name': 'Minas Gerais', 'abbreviation': 'MG' },
                { 'name': 'Pará', 'abbreviation': 'PA' },
                { 'name': 'Paraíba', 'abbreviation': 'PB' },
                { 'name': 'Paraná', 'abbreviation': 'PR' },
                { 'name': 'Pernambuco', 'abbreviation': 'PE' },
                { 'name': 'Piauí', 'abbreviation': 'PI' },
                { 'name': 'Rio de Janeiro', 'abbreviation': 'RJ' },
                { 'name': 'Rio Grande do Norte', 'abbreviation': 'RN' },
                { 'name': 'Rio Grande do Sul', 'abbreviation': 'RS' },
                { 'name': 'Rondônia', 'abbreviation': 'RO' },
                { 'name': 'Roraima', 'abbreviation': 'RR' },
                { 'name': 'Santa Catarina', 'abbreviation': 'SC' },
                { 'name': 'São Paulo', 'abbreviation': 'SP' },
                { 'name': 'Sergipe', 'abbreviation': 'SE' },
                { 'name': 'Tocantins', 'abbreviation': 'TO' }
            ]
        }
    }
}

Vue.component('zipcode-search', {
    twoWay: true,
    template: zipcodeSearchModalTemplate,
    props: {
        name: {
            twoWay: true,
            type: String
        },
        onSelected: {
            type: Function
        }
    },
    data () {
        return buildDefaults()
    },
    methods: {
        searchAddresses () {
            delete this.ui.page
            client
                .silent()
                .block(this.$els.modalBody)
                .post('Buscando.', `utils/addresses/search`, this.ui)
                .then((data) => {
                    this.isLoading = true
                    this.results = data.data
                    this.pagination = data.meta
                })
        },
        selectState () {
            client
                .silent()
                .block(this.$els.modalBody)
                .post('Buscando.', `utils/cities/search`, this.ui)
                .then((data) => {
                    this.filters.cities = data.data
                })
        },
        pushPage (a) {
            this.ui.page = a

            client
                .silent()
                .block(this.$els.modalBody)
                .post('Buscando.', `utils/addresses/search`, this.ui)
                .then((data) => {
                    this.results = data.data
                    this.pagination = data.meta
                })
        },
        selectCity () {
            client
                .silent()
                .block(this.$els.modalBody)
                .post('Buscando', `utils/neighborhoods/search`, this.ui)
                .then((data) => {
                    this.filters.neighborhoods = data.data
                })
        },
        clearSearch () {
            this.$data = buildDefaults()
        },
        selectAddress (result) {
            this.$refs.modalZipcode.hide()
            if (this.onSelected) {
                this.onSelected(result);
            }
        },
        showModal () {
            var maxZ = Math.max.apply(null,
                $.map($('body *'), function(e,n) {
                    if ($(e).css('position') != 'static')
                        return parseInt($(e).css('z-index')) || 1;
                }));
            $("#zipcodeSearchModal").css('z-index', maxZ+100);
            this.$refs.modalZipcode.show();
        },
        hideModal () {
            this.$refs.modalZipcode.hide()
            this.clearSearch()
        }
    },
    watch: {
        'ui.state' (newVal) {
            this.ui.city = null
            this.filters.cities = []

            if (newVal) {
                this.selectState()
            }
        },
        'ui.city' (newVal) {
            this.ui.neighborhood = null
            this.filters.neighborhoods = []

            if (newVal) {
                this.selectCity()
            }
        }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/zipcode-search.js